// extracted by mini-css-extract-plugin
module.exports = {"image":"_772e1b1e50--image--utOb4","no-photo":"_772e1b1e50--no-photo--cla0X"};